module.exports = __webpack_public_path__ + "static/50-44536c1e74746109544cef6c6035d5b7.png";